module.exports = __webpack_public_path__ + "static/media/gifdata.2fab3e19.gif";